import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {Button, Card, Checkbox, Select, Form, Input, notification} from 'antd';

import {addStaff} from './actions';
import {bindActionCreators} from "redux";
import {getDescriptionFromError} from "../utils/errors";
import {getStaffRoles} from "../StaffRole/actions";
import {formItemLayout} from "../utils/style";

const FormItem = Form.Item;
const Option = Select.Option;
const ButtonGroup = Button.Group;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class AddStaffForm extends Component {
  componentDidMount() {
    this.props.getStaffRoles();
  }

  goBack = () => {
    this.props.history.goBack();
  };

  handleSubmit = e => {
    const {selectedSalonId: salonId} = this.props;
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (err) return;
      this.props.addStaff({...values, salonId})
        .then(this.goBack)
        .catch(err => notification.error({
          message: 'Failed',
          description: getDescriptionFromError(err)
        }));
    });
  };

  render() {
    const {form: {getFieldDecorator, getFieldsError}, loading} = this.props;
    const {staffRoles, selectedSalonId} = this.props;
    return (
      <Card title="Add Staff">
        <Form onSubmit={this.handleSubmit}>
          <FormItem
            {...formItemLayout}
            label="Name"
          >
            {getFieldDecorator('name', {
              rules: [{
                required: true,
                message: 'Name is required'
              }]
            })(
              <Input />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Available At All Locations"
          >
            {getFieldDecorator('availableAtAllSalons', {
              rules: [],
              initialValue: false,
            })(
              <Checkbox />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Role"
          >
            {getFieldDecorator('staffRoleId', {
              rules: [{required: true, type: 'string'}],
            })(
              <Select placeholder="Select a role">
                {staffRoles.map(({staffRoleId, name}) => <Option key={staffRoleId} value={staffRoleId}>{name}</Option>)}
              </Select>
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Password"
          >
            {getFieldDecorator('password', {
              rules: [{required: true, min: 4}],
            })(
              <Input type="password" />
            )}
          </FormItem>
          <FormItem>
            <ButtonGroup>
              <Button
                type="primary"
                htmlType="submit"
                disabled={loading || hasErrors(getFieldsError()) || !selectedSalonId}
              >
                Add Staff
              </Button>
              <Button
                htmlType="button"
                onClick={this.goBack}
              >
                Cancel
              </Button>
            </ButtonGroup>
          </FormItem>
        </Form>
      </Card>
    );
  }
}

AddStaffForm.propTypes = {
  loading: PropTypes.bool.isRequired,
  form: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  selectedSalonId: PropTypes.string.isRequired,
  staffRoles: PropTypes.array.isRequired,
  /* actions */
  addStaff: PropTypes.func.isRequired,
  getStaffRoles: PropTypes.func.isRequired,
};

const AddStaffPage = Form.create()(AddStaffForm);

const mapStateToProps = state => ({
  loading: state.staff.addingStaff,
  selectedSalonId: state.salon.selectedSalonId,
  staffRoles: state.staffRole.staffRoles,
});

const mapDispatchToProps = dispatch => ({
  addStaff: bindActionCreators(addStaff, dispatch),
  getStaffRoles: bindActionCreators(getStaffRoles, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddStaffPage);



// WEBPACK FOOTER //
// ./src/Staff/AddStaffPage.js